import React from 'react';
import { motion } from 'framer-motion';
import { BriefcaseIcon, BuildingIcon, BarChartIcon } from 'lucide-react';
const solutions = [{
  id: 'agencies',
  icon: <BriefcaseIcon className="h-16 w-16 text-brand-teal" data-id="element-474" />,
  title: 'Agencies and Consultancies',
  description: 'Manage multiple clients and projects seamlessly',
  benefits: ['Centralised client communication', 'Project templates for faster setup', 'Time tracking and billing integration', 'Client-facing dashboards', 'Team workload management']
}, {
  id: 'service',
  icon: <BuildingIcon className="h-16 w-16 text-brand-teal" data-id="element-475" />,
  title: 'Service Businesses',
  description: 'Streamline service delivery and client relationships',
  benefits: ['Client onboarding workflows', 'Service milestone tracking', 'Automated status updates', 'Document sharing and approval', 'Customer satisfaction tracking']
}, {
  id: 'operations',
  icon: <BarChartIcon className="h-16 w-16 text-brand-teal" data-id="element-476" />,
  title: 'Internal Operations Teams',
  description: 'Coordinate cross-functional work effectively',
  benefits: ['Department collaboration tools', 'Stakeholder visibility', 'Process automation', 'Resource allocation', 'Performance metrics']
}];
export const Solutions = () => {
  return <div className="bg-white" data-id="element-477">
      <section className="py-16 md:py-24 bg-gradient-to-b from-white to-brand-light" data-id="element-478">
        <div className="container-custom" data-id="element-479">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-center max-w-3xl mx-auto" data-id="element-480">
            <h1 className="text-4xl md:text-5xl font-bold text-brand-blue mb-6" data-id="element-481">
              Solutions for every business
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-482">
              Daily Serve adapts to your unique workflow, whether you're
              managing clients or coordinating internal teams.
            </p>
          </motion.div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-483">
        <div className="container-custom" data-id="element-484">
          <div className="space-y-16" data-id="element-485">
            {solutions.map((solution, index) => <motion.div key={solution.id} id={solution.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-dense' : ''}`} data-id="element-486">
                <div className={index % 2 === 1 ? 'lg:col-start-2' : ''} data-id="element-487">
                  <div className="mb-6" data-id="element-488">{solution.icon}</div>
                  <h2 className="text-3xl font-bold text-brand-blue mb-4" data-id="element-489">
                    {solution.title}
                  </h2>
                  <p className="text-lg text-gray-600 mb-6" data-id="element-490">
                    {solution.description}
                  </p>
                  <ul className="space-y-3" data-id="element-491">
                    {solution.benefits.map((benefit, i) => <li key={i} className="flex items-start" data-id="element-492">
                        <span className="w-2 h-2 rounded-full bg-brand-teal mt-2 mr-3 flex-shrink-0" data-id="element-493"></span>
                        <span className="text-gray-700" data-id="element-494">{benefit}</span>
                      </li>)}
                  </ul>
                </div>
                <div className={index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''} data-id="element-495">
                  <div className="bg-brand-light rounded-lg p-8 h-64" data-id="element-496"></div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
};